import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle} || Coach John Mercer | Leadership and Executive Coaching</title>
                    <meta name="description" content="Coach John Mercer is an Executive and Leadership Coach with over 30 years experience coaching top executives and helping people reach their goals." />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
